// Ad-platform conversion events (GA4 + Meta Pixel) for the voice-ad checkout
// funnel. Both are no-ops unless index.html loaded gtag/fbq, which only
// happens when REACT_APP_GA_MEASUREMENT_ID / REACT_APP_META_PIXEL_ID are set
// at build time. Separate from api.trackEvent (internal funnel analytics) —
// this is specifically what ad platforms need to measure and optimize spend.

function purchaseTrackedKey(transactionId) {
  return `loudest_purchase_tracked_${transactionId}`;
}

export function trackBeginCheckout({ value, currency = 'USD', purpose } = {}) {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return;
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'begin_checkout', {
        currency,
        value: amount,
        items: [{ item_id: 'voice_ad', item_name: 'Loudest voice ad', item_variant: purpose }],
      });
    }
  } catch {}
  try {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', { currency, value: amount, content_name: 'Loudest voice ad' });
    }
  } catch {}
}

// Idempotent per Stripe checkout session id so a page refresh or a retried
// purchase-recovery call never double-counts a sale in ad-platform reporting.
export function trackPurchase({ transactionId, value, currency = 'USD', purpose } = {}) {
  const id = String(transactionId || '').trim();
  const amount = Number(value);
  if (!id || !Number.isFinite(amount) || amount <= 0) return;
  try {
    if (window.localStorage?.getItem(purchaseTrackedKey(id))) return;
  } catch {}
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'purchase', {
        transaction_id: id,
        currency,
        value: amount,
        items: [{ item_id: 'voice_ad', item_name: 'Loudest voice ad', item_variant: purpose }],
      });
    }
  } catch {}
  try {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Purchase', { currency, value: amount, content_name: 'Loudest voice ad' });
    }
  } catch {}
  try {
    window.localStorage?.setItem(purchaseTrackedKey(id), '1');
  } catch {}
}
